import { reactive, readonly } from "vue";

/* ================================
   🔥 ESTADO GLOBAL (SINGLETON)
================================ */
const loadingState = reactive({
  visible: false,
  progress: 0,
  title: "Carregando...",
  message: "Aguarde um instante",
  hint: "",
});

/* ================================
   🔧 AÇÕES
================================ */
function showLoading(payload = {}) {
  loadingState.visible = true;
  loadingState.progress = payload.progress ?? 0;
  loadingState.title = payload.title ?? "Carregando...";
  loadingState.message = payload.message ?? "Aguarde um instante";
  loadingState.hint = payload.hint ?? "";
}

function hideLoading() {
  loadingState.visible = false;
  loadingState.progress = 0;
}

/* ================================
   🧩 EXPORT ÚNICO
================================ */
export function useGlobalLoading() {
  return {
    loadingState: readonly(loadingState),
    showLoading,
    hideLoading,
  };
}
